/**
 * AirgrowBrand.jsx — AIRGROW Material Interface
 * 回転アイコン + AIRGROW ロゴブロック
 *
 * props:
 *   size     "sm" | "md"  (default: "md")
 *   layout   "horizontal" | "vertical"  (default: "vertical")
 *
 * sm / horizontal  : AcceptInvite の PageShell ヘッダー用（小サイズ・横並び）
 * md / vertical    : AuthLayout の右ドロワー用（中サイズ・縦積み）
 */
import React from 'react';
import { C } from '../../ColorTokens';

const SIZE_CONFIG = {
  sm: {
    box:        { width: 36, height: 36, borderRadius: 10, boxShadow: '0 4px 12px rgba(0,104,183,0.3)' },
    iconSize:   20,
    textSize:   22,
    letterSpacing: '-0.02em',
    showSubtitle: false,
  },
  md: {
    box:        { width: 48, height: 48, borderRadius: 14, boxShadow: '0 8px 24px rgba(0,104,183,0.3)' },
    iconSize:   24,
    textSize:   36,
    letterSpacing: '-0.03em',
    showSubtitle: true,
  },
};

export default function AirgrowBrand({ size = 'md', layout = 'vertical' }) {
  const cfg = SIZE_CONFIG[size] || SIZE_CONFIG.md;

  return (
    <div
      className={layout === 'horizontal' ? 'flex items-center' : 'flex flex-col items-center lg:items-start'}
      style={{ gap: '12px' }}
    >
      {/* 回転アイコンボックス */}
      <div
        className="flex items-center justify-center flex-shrink-0"
        style={{
          width:           cfg.box.width,
          height:          cfg.box.height,
          backgroundColor: C.primaryContainer,
          borderRadius:    cfg.box.borderRadius,
          transform:       'rotate(12deg)',
          boxShadow:       cfg.box.boxShadow,
        }}
      >
        <span
          className="material-symbols-outlined text-white"
          style={{ fontSize: cfg.iconSize, fontVariationSettings: "'FILL' 1" }}
        >
          airplanemode_active
        </span>
      </div>

      {/* テキスト */}
      <div className={layout === 'horizontal' ? '' : 'text-center lg:text-left'}>
        <p
          style={{
            fontFamily:    'Space Grotesk',
            fontSize:      cfg.textSize,
            fontWeight:    700,
            letterSpacing: cfg.letterSpacing,
            lineHeight:    1,
            color:         C.primary,
            margin:        0,
          }}
        >
          AIRGROW
        </p>
        {cfg.showSubtitle && (
          <p style={{ fontFamily: 'Noto Sans JP', fontSize: 12, color: C.onSurfaceVariant, margin: 0 }}>
            エンタープライズ・フライトコントロール
          </p>
        )}
      </div>
    </div>
  );
}
